export default __webpack_public_path__ + "resources/icons/n300-4d41.webp";